import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

import { SubFooter } from '@digital-platform/rs-cms/domain';
import {
  PrimaryFooterColumn,
  NestedSecondColumn,
} from '@digital-platform/rs-cms/domain';
import { BasePTypeComponent } from '../base-ptype/base-ptype.component';
import { DynamicContentWrapperComponent } from '../dynamic-content-wrapper/dynamic-content-wrapper.component';

@Component({
  selector: 'digital-platform-sub-footer',
  standalone: true,
  imports: [CommonModule, DynamicContentWrapperComponent],
  templateUrl: './sub-footer.component.html',
  styleUrls: ['./sub-footer.component.scss'],
})
export class SubFooterComponent
  extends BasePTypeComponent
  implements SubFooter
{
  public override type = 'subFooter' as const;

  @Input() nestedFirstColumn: PrimaryFooterColumn[] = [];
  @Input() nestedSecondColumn: NestedSecondColumn = [];

  get currentYear(): number {
    const currentDate = new Date();
    return currentDate.getFullYear();
  }
}
